import {
    getCoreRowModel,
    getFilteredRowModel,
    getPaginationRowModel,
    getSortedRowModel,
    useReactTable,
} from "@tanstack/react-table";
import { useEffect, useState } from 'react';
import { Link } from 'react-router';
import '../../App.css';
import api from '../../lib/api';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { DataTable } from './datatable';
import DatatableSortButton from './datatableSortButton';

export const columns = [
    {
        accessorKey: "name",
        header: ({ column }) => <DatatableSortButton column={column}>Kullnamn</DatatableSortButton>,
        cell: info => {
            const litter = info.row.original;
            return <Link to={`/litters/${litter.id}`} className='text-blue-600 font-medium hover:underline'>{litter.name}</Link>
        }
    },
    {
        accessorKey: "no_children",
        header: ({ column }) => <DatatableSortButton column={column}>Antal ungar</DatatableSortButton>,
    },
    {
        accessorKey: "birth_date",
        header: ({ column }) => <DatatableSortButton column={column}>Födelsedatum</DatatableSortButton>,
        cell: info => {
            const litter = info.row.original;
            const date = new Date(litter.birth_date);
            return date.toLocaleDateString('sv', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
            });
        }
    },
];

export function LittersDatatable({ farmId }) {
    const [sorting, setSorting] = useState([{ id: 'birth_date', desc: true }]);
    const [litters, setLitters] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [columnFilters, setColumnFilters] = useState([]);
    const [filterInput, setFilterInput] = useState("");

    const fetchLitters = async () => {
        setIsLoading(true);
        try {
            const response = await api.get(`https://skhrf-api.cmdigital.se/v1/farms/litters?farmId=${farmId}`)
            setLitters(response.data.litters);

        } catch (error) {
            console.error('Error fetching litters:', error)
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        fetchLitters();
    }, []);

    // Delay function before filtering to reduce bounce
    useEffect(() => {
        const handler = setTimeout(() => {
            table.getColumn("name")?.setFilterValue(filterInput);
        }, 500);

        return () => {
            clearTimeout(handler);
        };
    }, [filterInput]);

    const table = useReactTable({
        data: litters.length > 0 ? litters : [], // Ensure data is always an array
        columns: columns, // Pass auth here
        getCoreRowModel: getCoreRowModel(),
        getPaginationRowModel: getPaginationRowModel(),
        onSortingChange: setSorting,
        getSortedRowModel: getSortedRowModel(),
        onColumnFiltersChange: setColumnFilters,
        getFilteredRowModel: getFilteredRowModel(),
        state: {
            sorting,
            columnFilters,
        },
    });

    return (
        <>
            <div className='grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-3 py-3'>
                <div className='grid gap-3'>
                    <div className='flex flex-col gap-2'>
                        <Label htmlFor='searchLitter'>Kull</Label>
                        <Input
                            id='searchLitter'
                            placeholder="Sök kull..."
                            value={filterInput}
                            disabled={isLoading || litters.length === 0}
                            onChange={event => setFilterInput(event.target.value)}
                        />
                    </div>
                </div>
            </div>
            <DataTable table={table} isLoading={isLoading} columns={columns} />
        </>
    );
}